class RadialProgressBarController {
  constructor() {
    this.name = 'radialProgressBar';
  }

  progressClass() {
    return `progress-${this.stepProgress}`;
  }

  showProgressBar() {
    let hasProgress = this.stepProgress > 0 && this.stepProgress < 100;
    let hasError = this.stepError;
    return hasProgress && !hasError;
  }
}

export default RadialProgressBarController;



// WEBPACK FOOTER //
// ./app/components/radialProgressBar/radialProgressBar.controller.js